import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: {
    token: '',
    user: '',
  },
  authority: [],
  passwordExpired: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      return {
        ...state,
      };
    },
    loginSucceeded: (state, action) => {
      state.currentUser = action.payload;
      state.passwordExpired = '';
    },
    loginError: (state, action) => {
      return {
        ...state,
      };
    },
    getAuthority: () => {},
    getAuthoritySuccess: (state, action) => {
      state.authority = action.payload;
    },
    changePassword: (state, action) => {
      return {
        ...state,
      };
    },
    changePasswordSucceeded: (state, action) => {
      return {
        ...state,
      };
    },
    changePasswordError: (state, action) => {
      return {
        ...state,
      };
    },
    passwordExpired: (state) => {
      return {
        ...state,
        passwordExpired: '1',
      };
    },
    logout: (state) => {
      return {
        ...initialState,
        passwordExpired: state.passwordExpired,
      };
    },
  },
});

export const {
  login,
  loginSucceeded,
  loginError,

  changePassword,
  changePasswordSucceeded,
  changePasswordError,

  getAuthority,
  getAuthoritySuccess,

  passwordExpired,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
